import { useCallback } from 'react';

import { Workflows } from '../../../../../../tracking/tracking-constants';
import { useTrackWorkflow, WorkflowSteps } from '../../../../../../tracking/use-workflow-tracking';
import { useGetPromotionalMigrationPlan } from '../use-get-promotional-migration-plan';

/**
 * @param {number | string | object} value
 * @returns {number | string}
 */
const safeExtractFromObject = (value) => {
  if (typeof value === 'object') {
    return value?.limit ?? value?.value ?? 'unknown';
  }

  return value;
};

const tagPlanDetailsForSegment = (keyTag, planDetailsObject) => {
  if (!planDetailsObject) {
    return {};
  }
  const taggedEntries = Object.entries(planDetailsObject).map(([key, value]) => [`${keyTag}-${key}`, safeExtractFromObject(value)]);
  return Object.fromEntries(taggedEntries);
};

export const useTrackPromoModal = () => {
  const { promotionalPlanDetails, currentPlanDetails } = useGetPromotionalMigrationPlan();

  const trackPromotionalMigration = useTrackWorkflow(Workflows.PROMOTIONAL_PLAN_MIGRATION_FLOW);

  const trackPromoStartEvent = useCallback(
    (modalType) => {
      trackPromotionalMigration(WorkflowSteps.START, {
        ...tagPlanDetailsForSegment('current', currentPlanDetails),
        ...tagPlanDetailsForSegment('promo', promotionalPlanDetails),
        modalType,
      });
    },
    [currentPlanDetails, promotionalPlanDetails, trackPromotionalMigration],
  );

  const trackPromoCancelEvent = useCallback(() => trackPromotionalMigration(WorkflowSteps.CANCEL), [trackPromotionalMigration]);
  const trackPromoCompleteEvent = useCallback(() => trackPromotionalMigration(WorkflowSteps.COMPLETE), [trackPromotionalMigration]);
  const trackPromoErrorEvent = useCallback(
    (error) => {
      trackPromotionalMigration(WorkflowSteps.ERROR, {
        error,
      });
    },
    [trackPromotionalMigration],
  );
  const trackPromoContinueEvent = useCallback(() => trackPromotionalMigration(WorkflowSteps.CONTINUE), [trackPromotionalMigration]);

  const trackPromoAddPaymentClickEvent = useCallback(() => {
    trackPromotionalMigration(WorkflowSteps.ADD_PAYMENT_CLICKED);
  }, [trackPromotionalMigration]);

  const trackPromoAddPaymentCompleteEvent = useCallback(() => {
    trackPromotionalMigration(WorkflowSteps.ADD_PAYMENT_COMPLETE);
  }, [trackPromotionalMigration]);

  return {
    trackPromoStartEvent,
    trackPromoCancelEvent,
    trackPromoCompleteEvent,
    trackPromoErrorEvent,
    trackPromoContinueEvent,
    trackPromoAddPaymentClickEvent,
    trackPromoAddPaymentCompleteEvent,
  };
};
